import swal from 'sweetalert';

async function displayApiError({ props }) {
    const { error } = props;

    const message = [error.message];

    if (error.response && error.response.data && error.response.data.message) {
        message.push(error.response.data.message);
    }
    if (error.request && error.request.responseURL) {
        message.push('&nbsp;');
        message.push(error.request.responseURL);
    }

    await swal({
        title: 'Er liep iets mis..',
        content: {
            element: 'div',
            attributes: {
                innerHTML: `Contacteer Bits of Love en vermeld volgende boodschap:<br/> <div class="swal-error-details">${message.join(
                    '<br />'
                )}</div>`,
            },
        },
        icon: 'error',
    });
}

export default displayApiError;



// WEBPACK FOOTER //
// ./resources/assets/admin/common/modules/notifications/actions/displayApiError.js